/**
 * Dịch một lỗi bất kỳ thành câu người dùng đọc được.
 *
 * Thay cho `getErrorMessage()` cũ. Tách thành hook vì câu lỗi giờ đi qua
 * catalog, mà catalog chỉ đọc được trong React — và nhờ vậy dải lỗi đang hiện
 * **đổi ngôn ngữ ngay** khi người dùng chuyển, không đợi tải lại.
 */
import { useCallback } from 'react';

import { giaiLoi } from '../lib/errors';
import { useT } from '../i18n';

export function useLoi(): (err: unknown) => string {
  const { t } = useT();

  return useCallback(
    (err: unknown) => {
      const kq = giaiLoi(err);
      // Câu của backend tới lúc chạy, không có trong catalog — giữ nguyên văn.
      return kq.kieu === 'khoa' ? t(kq.khoa) : kq.cau;
    },
    [t],
  );
}
